import { useMutation } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useRefreshNotificationsMutation = () => {
  return useMutation({
    mutationFn: () => httpClient.get(`/notifications/refresh`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] })
    },
  })
}
